import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle } from 'lucide-react';
export function SolutionOverview() {
  const benefits = ['Ahorrás tiempo real (y energía mental)', 'Te sentís más seguro/a en cada decisión', 'Resolución rápida de patologías frecuentes', 'Seguimiento con criterio cuando no avanza', 'Comunicación lista para decir (sin improvisar)'];
  return <section className="pt-8 pb-6 px-3 max-w-3xl mx-auto" data-id="element-325">
      <FadeIn className="text-center mb-6" data-id="element-326">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 md:px-5 md:py-2 rounded-full border-2 border-accent/40 bg-accent/10 mb-4 whitespace-nowrap" data-id="element-327">
          <span className="text-lg md:text-xl" data-id="element-328">🏆</span>
          <h2 className="font-display text-sm md:text-xl lg:text-2xl font-bold text-accent" data-id="element-329">
            Sistema práctico para nutricionistas
          </h2>
        </div>

        <h3 className="text-lg md:text-xl font-bold mb-2" data-id="element-330">
          <span className="text-accent block" data-id="element-331">NUTRICIÓN DEPORTIVA 360º</span>
          <span className="text-white block" data-id="element-332">6 TOMOS + 6 BONOS</span>
          <span className="text-white/60 block text-sm md:text-base mt-1" data-id="element-333">
            Todo resuelto
          </span>
        </h3>
        <p className="text-white/70 text-sm md:text-base max-w-2xl mx-auto" data-id="element-334">
          +600 páginas · Checklists · Protocolos · Guiones · Plantillas.
          Funciona desde hoy.
        </p>
      </FadeIn>
    </section>;
}